export default __webpack_public_path__ + "static/media/profile-numbers.ecc86ece.svg";